// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PromptTemplatePopup-module__font-s-10___iPUa0 {
  font-size: 10px !important;
}

.PromptTemplatePopup-module__font-s-12___e69A1 {
  font-size: 12px !important;
}

.PromptTemplatePopup-module__font-s-13___Zupvb {
  font-size: 13px !important;
}

.PromptTemplatePopup-module__font-s-14___iziZQ {
  font-size: 14px !important;
}

.PromptTemplatePopup-module__font-s-15___lJVDr {
  font-size: 15px !important;
}

.PromptTemplatePopup-module__font-s-16___TOTy8 {
  font-size: 16px !important;
}

.PromptTemplatePopup-module__font-s-18___a8IXO {
  font-size: 18px !important;
}

.PromptTemplatePopup-module__font-s-20___SlDVY {
  font-size: 20px !important;
}

.PromptTemplatePopup-module__font-s-22___G6uJB {
  font-size: 22px !important;
}

.PromptTemplatePopup-module__font-s-28___LbBxJ {
  font-size: 28px !important;
}

.PromptTemplatePopup-module__font-w-400___llmUG {
  font-weight: 400 !important;
}

.PromptTemplatePopup-module__font-w-500___FoqZO {
  font-weight: 500 !important;
}

.PromptTemplatePopup-module__font-w-600___OH7mQ {
  font-weight: 600 !important;
}

.PromptTemplatePopup-module__font-w-700___OQ3O6 {
  font-weight: 700 !important;
}

.PromptTemplatePopup-module__p-5___n41xo {
  padding: 5px !important;
}

.PromptTemplatePopup-module__p-12___Dajch {
  padding: 12px !important;
}

.PromptTemplatePopup-module__p-16___N7e01 {
  padding: 16px !important;
}

.PromptTemplatePopup-module__p-30___UEUih {
  padding: 30px !important;
}

.PromptTemplatePopup-module__p-b-0___iMONO {
  padding-bottom: 0 !important;
}

.PromptTemplatePopup-module__p-b-5___BUNco {
  padding-bottom: 5px !important;
}

.PromptTemplatePopup-module__p-b-10___RivOr {
  padding-bottom: 10px !important;
}

.PromptTemplatePopup-module__p-b-12___LdZ0y {
  padding-bottom: 12px !important;
}

.PromptTemplatePopup-module__p-b-16___GWymi {
  padding-bottom: 16px !important;
}

.PromptTemplatePopup-module__p-b-18___a8ZW7 {
  padding-bottom: 18px !important;
}

.PromptTemplatePopup-module__p-b-20___l4WdK {
  padding-bottom: 20px !important;
}

.PromptTemplatePopup-module__p-b-25___eIg97 {
  padding-bottom: 25px !important;
}

.PromptTemplatePopup-module__p-b-30___AWTVD {
  padding-bottom: 30px !important;
}

.PromptTemplatePopup-module__p-b-50___vXNkI {
  padding-bottom: 50px !important;
}

.PromptTemplatePopup-module__p-t-0___zEi5N {
  padding-top: 0 !important;
}

.PromptTemplatePopup-module__p-t-12___m_dKb {
  padding-top: 12px !important;
}

.PromptTemplatePopup-module__p-t-16___eJffw {
  padding-top: 16px !important;
}

.PromptTemplatePopup-module__p-t-18___sV2JP {
  padding-top: 18px !important;
}

.PromptTemplatePopup-module__p-t-20___KSthN {
  padding-top: 20px !important;
}

.PromptTemplatePopup-module__p-t-30___Q7jY1 {
  padding-top: 30px !important;
}

.PromptTemplatePopup-module__p-t-40___GDseF {
  padding-top: 40px !important;
}

.PromptTemplatePopup-module__p-t-50___piSJX {
  padding-top: 50px !important;
}

.PromptTemplatePopup-module__p-l-20___YHoUC {
  padding-left: 20px !important;
}

.PromptTemplatePopup-module__p-l-30___TiPv8 {
  padding-left: 30px !important;
}

.PromptTemplatePopup-module__p-l-40___Iu2a8 {
  padding-left: 40px !important;
}

.PromptTemplatePopup-module__p-r-16___L1ItJ {
  padding-right: 16px !important;
}

.PromptTemplatePopup-module__p-r-20___rkvhb {
  padding-right: 20px !important;
}

.PromptTemplatePopup-module__p-r-30___ITJrp {
  padding-right: 30px !important;
}

.PromptTemplatePopup-module__p-r-50___oEQ_V {
  padding-right: 50px !important;
}

.PromptTemplatePopup-module__p-r-60____8Aee {
  padding-right: 60px !important;
}

.PromptTemplatePopup-module__m-b-1___mv52Y {
  margin-bottom: 1px !important;
}

.PromptTemplatePopup-module__m-b-2___zhCi_ {
  margin-bottom: 2px !important;
}

.PromptTemplatePopup-module__m-b-6___qHTbn {
  margin-bottom: 6px !important;
}

.PromptTemplatePopup-module__m-b-8___BVejV {
  margin-bottom: 8px !important;
}

.PromptTemplatePopup-module__m-b-10___KocFU {
  margin-bottom: 10px !important;
}

.PromptTemplatePopup-module__m-b-14___QD5xe {
  margin-bottom: 14px !important;
}

.PromptTemplatePopup-module__m-b-16___lNYpg {
  margin-bottom: 16px !important;
}

.PromptTemplatePopup-module__m-b-20___y0W6f {
  margin-bottom: 20px !important;
}

.PromptTemplatePopup-module__m-b-22___QD7hQ {
  margin-bottom: 22px !important;
}

.PromptTemplatePopup-module__m-b-24___wEe14 {
  margin-bottom: 24px !important;
}

.PromptTemplatePopup-module__m-b-30___ghpIZ {
  margin-bottom: 30px !important;
}

.PromptTemplatePopup-module__m-b-32___awlCU {
  margin-bottom: 32px !important;
}

.PromptTemplatePopup-module__m-b-40___d49oh {
  margin-bottom: 40px !important;
}

.PromptTemplatePopup-module__m-t-2___MXJfD {
  margin-top: 2px !important;
}

.PromptTemplatePopup-module__m-t-3___j1Sou {
  margin-top: 3px !important;
}

.PromptTemplatePopup-module__m-t-4___bKraH {
  margin-top: 4px !important;
}

.PromptTemplatePopup-module__m-t-5___kmRpr {
  margin-top: 5px !important;
}

.PromptTemplatePopup-module__m-t-8___uin6y {
  margin-top: 8px !important;
}

.PromptTemplatePopup-module__m-t-10___XnD0A {
  margin-top: 10px !important;
}

.PromptTemplatePopup-module__m-t-15___NVSxV {
  margin-top: 15px !important;
}

.PromptTemplatePopup-module__m-t-16____5LmJ {
  margin-top: 16px !important;
}

.PromptTemplatePopup-module__m-t-20___p8y6L {
  margin-top: 20px !important;
}

.PromptTemplatePopup-module__m-t-22___IO0Ni {
  margin-top: 22px !important;
}

.PromptTemplatePopup-module__m-t-30___PuoDP {
  margin-top: 30px !important;
}

.PromptTemplatePopup-module__m-t-32___q1C5n {
  margin-top: 32px !important;
}

.PromptTemplatePopup-module__m-l-auto___gQEEb {
  margin-left: auto !important;
}

.PromptTemplatePopup-module__m-l-4___o7Ozn {
  margin-left: 4px !important;
}

.PromptTemplatePopup-module__m-l-5___e6pfS {
  margin-left: 5px !important;
}

.PromptTemplatePopup-module__m-l-6___EFmbb {
  margin-left: 6px !important;
}

.PromptTemplatePopup-module__m-l-8___dgqe0 {
  margin-left: 8px !important;
}

.PromptTemplatePopup-module__m-l-10___USPRs {
  margin-left: 10px !important;
}

.PromptTemplatePopup-module__m-l-16___V2ZZ3 {
  margin-left: 16px !important;
}

.PromptTemplatePopup-module__m-l-20___vcoq8 {
  margin-left: 20px !important;
}

.PromptTemplatePopup-module__m-l-24___RkDRz {
  margin-left: 24px !important;
}

.PromptTemplatePopup-module__m-l-30___Nw8U8 {
  margin-left: 30px !important;
}

.PromptTemplatePopup-module__m-l-35___vvH5y {
  margin-left: 35px !important;
}

.PromptTemplatePopup-module__m-l-40___NlVZ1 {
  margin-left: 40px !important;
}

.PromptTemplatePopup-module__m-r-8___mtMNI {
  margin-right: 8px !important;
}

.PromptTemplatePopup-module__m-r-10___skE63 {
  margin-right: 10px !important;
}

.PromptTemplatePopup-module__m-r-16___wMOhX {
  margin-right: 16px !important;
}

.PromptTemplatePopup-module__m-r-20___ZoeoW {
  margin-right: 20px !important;
}

.PromptTemplatePopup-module__m-r-24___a1EAC {
  margin-right: 24px !important;
}

.PromptTemplatePopup-module__m-r-30___ka4KT {
  margin-right: 30px !important;
}

.PromptTemplatePopup-module__m-r-40___OhQNn {
  margin-right: 40px !important;
}

.PromptTemplatePopup-module__border-r-3___QMapn {
  border-radius: 3px !important;
}

.PromptTemplatePopup-module__border-r-4___oaExz {
  border-radius: 4px !important;
}

.PromptTemplatePopup-module__border-r-6___P4TVT {
  border-radius: 6px !important;
}

.PromptTemplatePopup-module__border-r-10___LCXuS {
  border-radius: 10px !important;
}

.PromptTemplatePopup-module__border-r-12___bu2z9 {
  border-radius: 12px !important;
}

.PromptTemplatePopup-module__border-r-16___l7XG9 {
  border-radius: 16px !important;
}

.PromptTemplatePopup-module__border-r-50___Zhu_u {
  border-radius: 50% !important;
}

.PromptTemplatePopup-module__primary-border___KZtR4 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.PromptTemplatePopup-module__primary-border-b___Zz6o3 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.PromptTemplatePopup-module__primary-border-t___tEuqL {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.PromptTemplatePopup-module__primary-border-l___YsO30 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.PromptTemplatePopup-module__primary-border-r___puoBo {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.PromptTemplatePopup-module__secondary-border___NOp4l {
  border: 1px solid #637768;
}

.PromptTemplatePopup-module__secondary-border-b___v9B4p {
  border-bottom: 1px solid #637768;
}

.PromptTemplatePopup-module__secondary-border-t___tywGS {
  border-top: 1px solid #637768;
}

.PromptTemplatePopup-module__secondary-border-l___SZmFa {
  border-left: 1px solid #637768;
}

.PromptTemplatePopup-module__secondary-border-r___lK1ZJ {
  border-right: 1px solid #637768;
}

.PromptTemplatePopup-module__gap-0___stfGE {
  gap: 0 !important;
}

.PromptTemplatePopup-module__gap-2___eCKKz {
  gap: 2px !important;
}

.PromptTemplatePopup-module__gap-4____w8tj {
  gap: 4px !important;
}

.PromptTemplatePopup-module__gap-5___hqQOD {
  gap: 5px !important;
}

.PromptTemplatePopup-module__gap-6___p4hed {
  gap: 6px !important;
}

.PromptTemplatePopup-module__gap-8___qsHBh {
  gap: 8px !important;
}

.PromptTemplatePopup-module__gap-10___HTahN {
  gap: 10px !important;
}

.PromptTemplatePopup-module__gap-12___B24uw {
  gap: 12px !important;
}

.PromptTemplatePopup-module__gap-14___Zo8bL {
  gap: 14px !important;
}

.PromptTemplatePopup-module__gap-16___dR3TW {
  gap: 16px !important;
}

.PromptTemplatePopup-module__gap-18___Xti_l {
  gap: 18px !important;
}

.PromptTemplatePopup-module__gap-20___e25N2 {
  gap: 20px !important;
}

.PromptTemplatePopup-module__gap-24___uYK6u {
  gap: 24px !important;
}

.PromptTemplatePopup-module__gap-26___wryT5 {
  gap: 26px !important;
}

.PromptTemplatePopup-module__gap-30___bf9Vi {
  gap: 30px !important;
}

.PromptTemplatePopup-module__gap-32___dexIG {
  gap: 32px !important;
}

.PromptTemplatePopup-module__gap-40___cD7BU {
  gap: 40px !important;
}

.PromptTemplatePopup-module__gap-50___ZWUg9 {
  gap: 50px !important;
}

.PromptTemplatePopup-module__flex-1___Pebgh {
  flex: 1;
}

.PromptTemplatePopup-module__flex-none___iMtic {
  flex: none !important;
}

.PromptTemplatePopup-module__flex-column___GQopx {
  display: flex;
  flex-direction: column !important;
}

.PromptTemplatePopup-module__flex-row___g4m8f {
  display: flex;
  flex-direction: row !important;
}

.PromptTemplatePopup-module__vertically-centered___KmE0o {
  display: flex;
  align-items: center !important;
}

.PromptTemplatePopup-module__horizontally-centered___GShhV {
  display: flex;
  justify-content: center !important;
}

.PromptTemplatePopup-module__horizontally-end___QIvy1 {
  display: flex;
  justify-content: end !important;
}

.PromptTemplatePopup-module__vertically-start___h89FI {
  display: flex;
  align-items: start !important;
}

.PromptTemplatePopup-module__space-between___OQJB_ {
  display: flex;
  justify-content: space-between !important;
}

.PromptTemplatePopup-module__flex-wrap___Voh9W {
  flex-wrap: wrap !important;
}

.PromptTemplatePopup-module__height-100___iPbz9 {
  height: 100%;
}

.PromptTemplatePopup-module__width-50___KXfis {
  width: 50% !important;
}

.PromptTemplatePopup-module__width-100___q3WvA {
  width: 100%;
}

.PromptTemplatePopup-module__cursor-pointer___FJmUn {
  cursor: pointer;
}

.PromptTemplatePopup-module__cursor-not-allowed___oV0CE {
  cursor: not-allowed !important;
}

.PromptTemplatePopup-module__absolute-centered___xThOe {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.PromptTemplatePopup-module__absolute___Geqqv {
  position: absolute;
}

.PromptTemplatePopup-module__relative___kf8uK {
  position: relative;
}

.PromptTemplatePopup-module__fixed___Gytc7 {
  position: fixed;
}

.PromptTemplatePopup-module__visible___yLd3d {
  opacity: 1;
}

.PromptTemplatePopup-module__invisible___kC3yN {
  opacity: 0;
}

.PromptTemplatePopup-module__col-90___f5npJ {
  width: 90% !important;
}

.PromptTemplatePopup-module__col-auto___YrS1a {
  width: auto !important;
}

.PromptTemplatePopup-module__medical-tabs___vOG9u {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.PromptTemplatePopup-module__medical-table-new___EtaAx {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.PromptTemplatePopup-module__medical-table-new___EtaAx:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.PromptTemplatePopup-module__medical-table-new___EtaAx::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.PromptTemplatePopup-module__medical-table-new___EtaAx::-webkit-scrollbar-track {
  display: none;
}
.PromptTemplatePopup-module__medical-table-new___EtaAx.PromptTemplatePopup-module__no-pagination___wuCxF {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.PromptTemplatePopup-module__medical-table-new___EtaAx.PromptTemplatePopup-module__no-pagination___wuCxF:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.PromptTemplatePopup-module__medical-table-new___EtaAx.PromptTemplatePopup-module__no-pagination___wuCxF::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.PromptTemplatePopup-module__medical-table-new___EtaAx.PromptTemplatePopup-module__no-pagination___wuCxF::-webkit-scrollbar-track {
  display: none;
}

.PromptTemplatePopup-module__medical-table-empty___Z8Irq {
  padding: 14px 40px !important;
}

.PromptTemplatePopup-module__icon-btn___NmQRs {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.PromptTemplatePopup-module__search-icon___XSUb1 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.PromptTemplatePopup-module__disable-select___a1B0m {
  user-select: none;
}

.PromptTemplatePopup-module__break-word___IuJCA {
  word-break: break-word;
}

.PromptTemplatePopup-module__popup-clear-btn___F5R70 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.PromptTemplatePopup-module__scroll-m-b-20___QEG8B {
  scroll-margin-bottom: 20px;
}

.PromptTemplatePopup-module__content___upj4m {
  padding: 25px 30px;
}
.PromptTemplatePopup-module__content___upj4m .PromptTemplatePopup-module__select___OlNI_ button {
  opacity: 0.5;
  color: #859989 !important;
}

.PromptTemplatePopup-module__buttonsContainer___nF3Hm {
  gap: 16px;
  padding: 30px;
  display: flex;
  justify-content: end;
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.PromptTemplatePopup-module__checkbox___NTV6E {
  flex-direction: row-reverse;
  margin-right: -10px;
  gap: 10px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/PromptTemplatePopup/PromptTemplatePopup.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,kBAAA;AA8pBF;AA3pBI;EACE,YAAA;EACA,yBAAA;AA6pBN;;AAxpBA;EACE,SAAA;EACA,aAAA;EACA,aAAA;EACA,oBAAA;EACA,2CAAA;AA2pBF;;AAxpBA;EACE,2BAAA;EACA,mBAAA;EACA,SAAA;AA2pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.content {\n  padding: 25px 30px;\n\n  .select {\n    button {\n      opacity: 0.5;\n      color: get-color(greenNew, medium) !important;\n    }\n  }\n}\n\n.buttonsContainer {\n  gap: 16px;\n  padding: 30px;\n  display: flex;\n  justify-content: end;\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.checkbox {\n  flex-direction: row-reverse;\n  margin-right: -10px;\n  gap: 10px;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `PromptTemplatePopup-module__font-s-10___iPUa0`,
	"fontS12": `PromptTemplatePopup-module__font-s-12___e69A1`,
	"fontS13": `PromptTemplatePopup-module__font-s-13___Zupvb`,
	"fontS14": `PromptTemplatePopup-module__font-s-14___iziZQ`,
	"fontS15": `PromptTemplatePopup-module__font-s-15___lJVDr`,
	"fontS16": `PromptTemplatePopup-module__font-s-16___TOTy8`,
	"fontS18": `PromptTemplatePopup-module__font-s-18___a8IXO`,
	"fontS20": `PromptTemplatePopup-module__font-s-20___SlDVY`,
	"fontS22": `PromptTemplatePopup-module__font-s-22___G6uJB`,
	"fontS28": `PromptTemplatePopup-module__font-s-28___LbBxJ`,
	"fontW400": `PromptTemplatePopup-module__font-w-400___llmUG`,
	"fontW500": `PromptTemplatePopup-module__font-w-500___FoqZO`,
	"fontW600": `PromptTemplatePopup-module__font-w-600___OH7mQ`,
	"fontW700": `PromptTemplatePopup-module__font-w-700___OQ3O6`,
	"p5": `PromptTemplatePopup-module__p-5___n41xo`,
	"p12": `PromptTemplatePopup-module__p-12___Dajch`,
	"p16": `PromptTemplatePopup-module__p-16___N7e01`,
	"p30": `PromptTemplatePopup-module__p-30___UEUih`,
	"pB0": `PromptTemplatePopup-module__p-b-0___iMONO`,
	"pB5": `PromptTemplatePopup-module__p-b-5___BUNco`,
	"pB10": `PromptTemplatePopup-module__p-b-10___RivOr`,
	"pB12": `PromptTemplatePopup-module__p-b-12___LdZ0y`,
	"pB16": `PromptTemplatePopup-module__p-b-16___GWymi`,
	"pB18": `PromptTemplatePopup-module__p-b-18___a8ZW7`,
	"pB20": `PromptTemplatePopup-module__p-b-20___l4WdK`,
	"pB25": `PromptTemplatePopup-module__p-b-25___eIg97`,
	"pB30": `PromptTemplatePopup-module__p-b-30___AWTVD`,
	"pB50": `PromptTemplatePopup-module__p-b-50___vXNkI`,
	"pT0": `PromptTemplatePopup-module__p-t-0___zEi5N`,
	"pT12": `PromptTemplatePopup-module__p-t-12___m_dKb`,
	"pT16": `PromptTemplatePopup-module__p-t-16___eJffw`,
	"pT18": `PromptTemplatePopup-module__p-t-18___sV2JP`,
	"pT20": `PromptTemplatePopup-module__p-t-20___KSthN`,
	"pT30": `PromptTemplatePopup-module__p-t-30___Q7jY1`,
	"pT40": `PromptTemplatePopup-module__p-t-40___GDseF`,
	"pT50": `PromptTemplatePopup-module__p-t-50___piSJX`,
	"pL20": `PromptTemplatePopup-module__p-l-20___YHoUC`,
	"pL30": `PromptTemplatePopup-module__p-l-30___TiPv8`,
	"pL40": `PromptTemplatePopup-module__p-l-40___Iu2a8`,
	"pR16": `PromptTemplatePopup-module__p-r-16___L1ItJ`,
	"pR20": `PromptTemplatePopup-module__p-r-20___rkvhb`,
	"pR30": `PromptTemplatePopup-module__p-r-30___ITJrp`,
	"pR50": `PromptTemplatePopup-module__p-r-50___oEQ_V`,
	"pR60": `PromptTemplatePopup-module__p-r-60____8Aee`,
	"mB1": `PromptTemplatePopup-module__m-b-1___mv52Y`,
	"mB2": `PromptTemplatePopup-module__m-b-2___zhCi_`,
	"mB6": `PromptTemplatePopup-module__m-b-6___qHTbn`,
	"mB8": `PromptTemplatePopup-module__m-b-8___BVejV`,
	"mB10": `PromptTemplatePopup-module__m-b-10___KocFU`,
	"mB14": `PromptTemplatePopup-module__m-b-14___QD5xe`,
	"mB16": `PromptTemplatePopup-module__m-b-16___lNYpg`,
	"mB20": `PromptTemplatePopup-module__m-b-20___y0W6f`,
	"mB22": `PromptTemplatePopup-module__m-b-22___QD7hQ`,
	"mB24": `PromptTemplatePopup-module__m-b-24___wEe14`,
	"mB30": `PromptTemplatePopup-module__m-b-30___ghpIZ`,
	"mB32": `PromptTemplatePopup-module__m-b-32___awlCU`,
	"mB40": `PromptTemplatePopup-module__m-b-40___d49oh`,
	"mT2": `PromptTemplatePopup-module__m-t-2___MXJfD`,
	"mT3": `PromptTemplatePopup-module__m-t-3___j1Sou`,
	"mT4": `PromptTemplatePopup-module__m-t-4___bKraH`,
	"mT5": `PromptTemplatePopup-module__m-t-5___kmRpr`,
	"mT8": `PromptTemplatePopup-module__m-t-8___uin6y`,
	"mT10": `PromptTemplatePopup-module__m-t-10___XnD0A`,
	"mT15": `PromptTemplatePopup-module__m-t-15___NVSxV`,
	"mT16": `PromptTemplatePopup-module__m-t-16____5LmJ`,
	"mT20": `PromptTemplatePopup-module__m-t-20___p8y6L`,
	"mT22": `PromptTemplatePopup-module__m-t-22___IO0Ni`,
	"mT30": `PromptTemplatePopup-module__m-t-30___PuoDP`,
	"mT32": `PromptTemplatePopup-module__m-t-32___q1C5n`,
	"mLAuto": `PromptTemplatePopup-module__m-l-auto___gQEEb`,
	"mL4": `PromptTemplatePopup-module__m-l-4___o7Ozn`,
	"mL5": `PromptTemplatePopup-module__m-l-5___e6pfS`,
	"mL6": `PromptTemplatePopup-module__m-l-6___EFmbb`,
	"mL8": `PromptTemplatePopup-module__m-l-8___dgqe0`,
	"mL10": `PromptTemplatePopup-module__m-l-10___USPRs`,
	"mL16": `PromptTemplatePopup-module__m-l-16___V2ZZ3`,
	"mL20": `PromptTemplatePopup-module__m-l-20___vcoq8`,
	"mL24": `PromptTemplatePopup-module__m-l-24___RkDRz`,
	"mL30": `PromptTemplatePopup-module__m-l-30___Nw8U8`,
	"mL35": `PromptTemplatePopup-module__m-l-35___vvH5y`,
	"mL40": `PromptTemplatePopup-module__m-l-40___NlVZ1`,
	"mR8": `PromptTemplatePopup-module__m-r-8___mtMNI`,
	"mR10": `PromptTemplatePopup-module__m-r-10___skE63`,
	"mR16": `PromptTemplatePopup-module__m-r-16___wMOhX`,
	"mR20": `PromptTemplatePopup-module__m-r-20___ZoeoW`,
	"mR24": `PromptTemplatePopup-module__m-r-24___a1EAC`,
	"mR30": `PromptTemplatePopup-module__m-r-30___ka4KT`,
	"mR40": `PromptTemplatePopup-module__m-r-40___OhQNn`,
	"borderR3": `PromptTemplatePopup-module__border-r-3___QMapn`,
	"borderR4": `PromptTemplatePopup-module__border-r-4___oaExz`,
	"borderR6": `PromptTemplatePopup-module__border-r-6___P4TVT`,
	"borderR10": `PromptTemplatePopup-module__border-r-10___LCXuS`,
	"borderR12": `PromptTemplatePopup-module__border-r-12___bu2z9`,
	"borderR16": `PromptTemplatePopup-module__border-r-16___l7XG9`,
	"borderR50": `PromptTemplatePopup-module__border-r-50___Zhu_u`,
	"primaryBorder": `PromptTemplatePopup-module__primary-border___KZtR4`,
	"primaryBorderB": `PromptTemplatePopup-module__primary-border-b___Zz6o3`,
	"primaryBorderT": `PromptTemplatePopup-module__primary-border-t___tEuqL`,
	"primaryBorderL": `PromptTemplatePopup-module__primary-border-l___YsO30`,
	"primaryBorderR": `PromptTemplatePopup-module__primary-border-r___puoBo`,
	"secondaryBorder": `PromptTemplatePopup-module__secondary-border___NOp4l`,
	"secondaryBorderB": `PromptTemplatePopup-module__secondary-border-b___v9B4p`,
	"secondaryBorderT": `PromptTemplatePopup-module__secondary-border-t___tywGS`,
	"secondaryBorderL": `PromptTemplatePopup-module__secondary-border-l___SZmFa`,
	"secondaryBorderR": `PromptTemplatePopup-module__secondary-border-r___lK1ZJ`,
	"gap0": `PromptTemplatePopup-module__gap-0___stfGE`,
	"gap2": `PromptTemplatePopup-module__gap-2___eCKKz`,
	"gap4": `PromptTemplatePopup-module__gap-4____w8tj`,
	"gap5": `PromptTemplatePopup-module__gap-5___hqQOD`,
	"gap6": `PromptTemplatePopup-module__gap-6___p4hed`,
	"gap8": `PromptTemplatePopup-module__gap-8___qsHBh`,
	"gap10": `PromptTemplatePopup-module__gap-10___HTahN`,
	"gap12": `PromptTemplatePopup-module__gap-12___B24uw`,
	"gap14": `PromptTemplatePopup-module__gap-14___Zo8bL`,
	"gap16": `PromptTemplatePopup-module__gap-16___dR3TW`,
	"gap18": `PromptTemplatePopup-module__gap-18___Xti_l`,
	"gap20": `PromptTemplatePopup-module__gap-20___e25N2`,
	"gap24": `PromptTemplatePopup-module__gap-24___uYK6u`,
	"gap26": `PromptTemplatePopup-module__gap-26___wryT5`,
	"gap30": `PromptTemplatePopup-module__gap-30___bf9Vi`,
	"gap32": `PromptTemplatePopup-module__gap-32___dexIG`,
	"gap40": `PromptTemplatePopup-module__gap-40___cD7BU`,
	"gap50": `PromptTemplatePopup-module__gap-50___ZWUg9`,
	"flex1": `PromptTemplatePopup-module__flex-1___Pebgh`,
	"flexNone": `PromptTemplatePopup-module__flex-none___iMtic`,
	"flexColumn": `PromptTemplatePopup-module__flex-column___GQopx`,
	"flexRow": `PromptTemplatePopup-module__flex-row___g4m8f`,
	"verticallyCentered": `PromptTemplatePopup-module__vertically-centered___KmE0o`,
	"horizontallyCentered": `PromptTemplatePopup-module__horizontally-centered___GShhV`,
	"horizontallyEnd": `PromptTemplatePopup-module__horizontally-end___QIvy1`,
	"verticallyStart": `PromptTemplatePopup-module__vertically-start___h89FI`,
	"spaceBetween": `PromptTemplatePopup-module__space-between___OQJB_`,
	"flexWrap": `PromptTemplatePopup-module__flex-wrap___Voh9W`,
	"height100": `PromptTemplatePopup-module__height-100___iPbz9`,
	"width50": `PromptTemplatePopup-module__width-50___KXfis`,
	"width100": `PromptTemplatePopup-module__width-100___q3WvA`,
	"cursorPointer": `PromptTemplatePopup-module__cursor-pointer___FJmUn`,
	"cursorNotAllowed": `PromptTemplatePopup-module__cursor-not-allowed___oV0CE`,
	"absoluteCentered": `PromptTemplatePopup-module__absolute-centered___xThOe`,
	"absolute": `PromptTemplatePopup-module__absolute___Geqqv`,
	"relative": `PromptTemplatePopup-module__relative___kf8uK`,
	"fixed": `PromptTemplatePopup-module__fixed___Gytc7`,
	"visible": `PromptTemplatePopup-module__visible___yLd3d`,
	"invisible": `PromptTemplatePopup-module__invisible___kC3yN`,
	"col90": `PromptTemplatePopup-module__col-90___f5npJ`,
	"colAuto": `PromptTemplatePopup-module__col-auto___YrS1a`,
	"medicalTabs": `PromptTemplatePopup-module__medical-tabs___vOG9u`,
	"medicalTableNew": `PromptTemplatePopup-module__medical-table-new___EtaAx`,
	"noPagination": `PromptTemplatePopup-module__no-pagination___wuCxF`,
	"medicalTableEmpty": `PromptTemplatePopup-module__medical-table-empty___Z8Irq`,
	"iconBtn": `PromptTemplatePopup-module__icon-btn___NmQRs`,
	"searchIcon": `PromptTemplatePopup-module__search-icon___XSUb1`,
	"disableSelect": `PromptTemplatePopup-module__disable-select___a1B0m`,
	"breakWord": `PromptTemplatePopup-module__break-word___IuJCA`,
	"popupClearBtn": `PromptTemplatePopup-module__popup-clear-btn___F5R70`,
	"scrollMB20": `PromptTemplatePopup-module__scroll-m-b-20___QEG8B`,
	"content": `PromptTemplatePopup-module__content___upj4m`,
	"select": `PromptTemplatePopup-module__select___OlNI_`,
	"buttonsContainer": `PromptTemplatePopup-module__buttonsContainer___nF3Hm`,
	"checkbox": `PromptTemplatePopup-module__checkbox___NTV6E`
};
module.exports = ___CSS_LOADER_EXPORT___;
